module.exports = __webpack_public_path__ + "img/rmillarium64_ua.bbd206be.webp";